<template lang="pug">
section.detail-legal(:style="{ marginBottom: `${margin}px` }")
	small(v-html="text")
</template>

<script>
export default {
	name: "Legal",
	props: ["text", "margin"]
}
</script>


<style lang="scss" scoped>
	.detail-legal {
		font-family: HelveticaNeueW02-57Cn;
		font-size: 18px;
	}
</style>
